import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { MultiTextComponent } from './quizzing/MultiTextComponent';
import { ButtonComponent } from './quizzing/ButtonComponent';
import { TextComponent } from './quizzing/TextComponent';
import { dataItem } from '../data/data';
import { AppHelper } from '../helpers/AppHelper';
import { ValidationHelper } from '../common/helpers/ValidationHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppTheme } from '../styles/AppTheme';
import { Document, Page } from 'react-pdf';
import { MsgDialog } from '../components/MsgDialog';
import { Controller } from '../common/Controller';
import { RadioComponent } from '../components/quizzing/RadioComponent';
import { AppConfig } from '../AppConfig';
import CircularProgress from '@material-ui/core/CircularProgress';

export class Consent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consentStatus: '',
      fetchState: ApiHelper.State.LOADING,
      loadingDoc: true,
      showMsgDialog: false,
    }
    this.profileComplete = AppHelper.isProfileSectionComplete(this.props.currentStep)
    this.consent = null
    this.consentWaiver = null
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems() {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], { groupId: 'doc' }) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        if(!result || !result.items) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
        }

        for(const r of result.items) {
          if(r.itemId === 'CONSENT_WAIVER') {
            this.consentWaiver = r.doc
          }
          if(r.itemId === 'CONSENT') {
            this.consent = r.doc
          }
        }

        this.setState({
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  validateFieldsAndSubmit() {
    let valid = true
    for (const key in this.props.formFieldsParentConsent) {
      if (ValidationHelper.validateFields(this.props.formFieldsParentConsent[key], this.props.responseByQuestionId[this.props.formFieldsParentConsent[key].id])) {
        valid = false
      }
    }
    if (valid) {
      this.props.nextStepper()
    }
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({
      loadingDoc: false,
      numPages: numPages
    })
  }

  downloadFile(url) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank')
    document.body.appendChild(link);
    link.click();
  }

  handleState = (id, value) => {
    this.setState({
      [id]: value
    })
  }

  renderRadio = () => {
    return (
      <RadioComponent
        value={this.state.consentStatus}
        data={{
          id: 'consentStatus',
          options: [{
            id: 'giveConsent',
            order: '1',
            title: Helper.getString('giveConsent')
          },
          {
            id: 'denyConsent',
            order: '2',
            title: Helper.getString('denyConsent')
          }]
        }}
        handleState={this.handleState}
        type={'YESNO'}
      />
    )
  }

  getWidth = () => {
    if(window.innerWidth > 1100) {
      return 900
    } else if(window.innerWidth > 767) {
      return 700
    } else {
      return window.innerWidth - 50
    }
  }

  renderPdf = (docUrl) => {
    return (
      <div className={css(Styles.docContainer)}>
        {this.state.loadingDoc &&
          <CircularProgress size={48} className={css(Styles.progress)} />
        }
        <Document
          file={docUrl}
          loading=''
          onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
        >
          {Array.from(
            new Array(this.state.numPages),
            (el, index) => (
              <Page
                width={this.getWidth()}
                key={`page_${index + 1}`}
                pageNumber={index + 1}
              />
            ),
          )}
        </Document>
      </div>
    )
  }

  getParentDetails = () => {
    return (
      <div className={css(CommonStyles.stepperInnerContent, CommonStyles.innerErrorContainer)}>
        <p className={css(CommonStyles.stepperTitleContent, Styles.customTitle)}>Parent Information</p>
        <p className={css(CommonStyles.stepperSubTitleContent, Styles.customStepperSubTitleContent)}>
          {'Enter Parent Name and Email'}
        </p>
        <div className={css(Styles.signatureTextContainer)}>
          <TextComponent
            value={this.props.responseByQuestionId[this.props.formFieldsParentConsent.consentGuardianName.id]}
            data={this.props.formFieldsParentConsent.consentGuardianName}
            mainTitle={this.props.formFieldsParentConsent.consentGuardianName.title}
            handleState={this.props.handleState}
            survey={false}
            enableValidation={true}
            disabled={this.profileComplete || this.props.formFieldsParentConsent.consentGuardianName.disabled}
          />
          <TextComponent
            value={this.props.responseByQuestionId[this.props.formFieldsParentConsent.consentGuardianEmail.id]}
            data={this.props.formFieldsParentConsent.consentGuardianEmail}
            mainTitle={this.props.formFieldsParentConsent.consentGuardianEmail.title}
            handleState={this.props.handleState}
            survey={false}
            enableValidation={true}
            disabled={this.profileComplete || this.props.formFieldsParentConsent.consentGuardianName.disabled}
          />
        </div>
      </div>
    )
  }

  closeMsgDialog = () => {
    this.setState({
      showMsgDialog: false
    })
    if (!this.state.consentError) {
      Controller.get().logout()
      window.location.reload()
    }
  }

  onContinue = () => {
    const appUser = Controller.get().userMgr().getAppUser()
    if (this.props.consentCheck) {
      console.log('consentCheck')
      if (this.props.adult) {
        this.props.nextStepper()
      } else {
        this.validateFieldsAndSubmit()
      }
    } else {
      if (!this.state.consentStatus || this.state.consentStatus.length === 0) {
        this.setState({
          showMsgDialog: true,
          msg: Helper.getString('consentSelectError'),
          consentError: true
        })
        return
      } else if (this.state.consentStatus === 'denyConsent') {
        this.setState({
          showMsgDialog: true,
          msg: Helper.getString('denyConsentDescr'),
          consentError: false
        })
        return
      } else if (this.state.consentStatus === 'giveConsent') {
        this.setState({
          consentError: false
        })
        if (appUser.state !== 'READY' && this.props.adult) {
          this.downloadFile(this.consentWaiver)
        }
        if (this.props.adult) {
          this.props.nextStepper()
        } else {
          this.validateFieldsAndSubmit()
        }
        return
      }
    }

  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    const appUser = Controller.get().userMgr().getAppUser()
    this.profileComplete = AppHelper.isProfileSectionComplete(this.props.currentStep)
    return (
      <div className={css(CommonStyles.stepperInnerContainer)}>

        {/*this.props.consentCheck && !this.profileComplete &&
          !this.props.adult &&
          <div className={css(CommonStyles.stepperInnerContent)}>
            <p className={css(CommonStyles.stepperTitleContent)}>Go grab a parent or guardian for a quick signature…</p>
            <div className={css(CommonStyles.buttonContainer)}>
              <ButtonComponent
                label='CONTINUE'
                inProcess={this.props.inProcess}
                onSelect={this.props.continueButton}
              />
            </div>
          </div>
        */}

        {
          <div className={css(CommonStyles.stepperInnerContent, CommonStyles.innerErrorContainer)}>
            {this.props.adult &&
              <p className={css(CommonStyles.stepperTitleContent, Styles.stepperTitle)}>{Helper.getString('consentTitleForAgeOverEighteen')}</p>
            }

            {/*!this.props.adult &&
              <p className={css(CommonStyles.stepperTitleContent)}>Research Subject Consent & Assent</p>
            */}

            <div className={css(Styles.marginTop)}></div>

            {!this.props.adult && appUser.state === 'CONTACT_INFO_DONE' &&
              <p className={css(CommonStyles.stepperSubTitleContent, Styles.customStepperSubTitleContent)}>{Helper.getString('infoForAgeUnder18')}</p>
            }

            {!this.props.adult && appUser.state === 'CONSENT_DONE_PARENT_PENDING' &&
              <div>
                <p className={css(CommonStyles.stepperSubTitleContent, Styles.customStepperSubTitleContent, Styles.customColor)}>{Helper.getString('consentPendingFromParentsStr1')}</p>
                <p className={css(CommonStyles.stepperSubTitleContent, Styles.customStepperSubTitleContent, Styles.customColor)}>{Helper.getString('consentPendingFromParentsStr2')}</p>
              </div>
            }

            {/*this.props.adult &&
              <p className={css(CommonStyles.stepperSubTitleContent, Styles.customStepperSubTitleContent)}>Please read the document</p>
            */}

            {/*<a href={this.props.adult ? this.consentWaiver : this.consent}
              //target='_blank'
              className={css(CommonStyles.link)}
              download>
              <ButtonComponent
                label='DOWNLOAD / VIEW DOCUMENT'
                className={css(CommonStyles.buttonVariant)}
                onSelect={() => console.log('')}
              />
            </a>*/}

            {this.props.adult &&
              this.renderPdf(this.consentWaiver)
            }

            {!this.props.adult &&
              <div className={css(Styles.parentInfoContainer)}>
                {this.getParentDetails()}
              </div>
            }

            {this.props.adult && !this.profileComplete &&
              <div className={css(Styles.optionsContainer)}>
                {this.renderRadio()}
              </div>
            }



            <div className={css(CommonStyles.buttonContainer)}>
              {/*<ButtonComponent
              label='DOWNLOAD'
              inProcess={this.props.inProcess}
              onSelect={this.props.nextStepper}
              className={css(CommonStyles.buttonContainerSecond)}
            />*/}
              {!this.profileComplete &&
                <ButtonComponent
                  //label= {this.state.consentStatus === 'denyConsent' ? 'CLOSE' : 'AGREE & CONTINUE'}
                  label= {'SUBMIT'}
                  inProcess={this.props.inProcess}
                  onSelect={this.onContinue}
                />
              }
              {this.props.adult && this.profileComplete && appUser.state !== 'READY' &&
                <ButtonComponent
                  label= {'CONTINUE'}
                  inProcess={this.props.inProcess}
                  onSelect={() => this.props.doUpdatePreferedQSections()}
                />
              }
            </div>
          </div>
        }

        <MsgDialog
          showDialog={this.state.showMsgDialog}
          closeDialog={this.closeMsgDialog}
          title={this.state.consentError ? 'Please Note!' : 'Thank you!'}
          rightBtnTitle={'OK'}
          descr={this.state.msg}
        />
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  signatureTextContainer: {
    marginTop: 20,
    width: '100%',
    textAlign: 'left'
  },
  parentInfoContainer: {
    marginTop: 30,
  },
  customStepperSubTitleContent: {
    color: AppTheme.textColor,
    fontSize: 23,
    margin: 0,
  },
  marginTop: {
    marginTop: 25,
  },
  customTitle: {
    fontSize: 35,
    marginBottom: 5,
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  docContainer: {
    //display: 'flex',
    //alignItems: 'center',
    //marginTop: 10,
    height: 400,
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (max-width: 767px)': {
      height: 300,
    }
  },
  stepperTitle: {
    fontSize: 40,
  },
  customColor: {
    color: AppTheme.secondaryColor
  },
  progress: {
    color: AppTheme.primaryColor
  },
})


// WEBPACK FOOTER //
// ./src/components/Consent.js